/** import custom dependency [start] */
import { axiosBackendInstance } from '../utils/axios';
import { LooseObject } from './types';
/** import custom dependency [end] */

export const defaultRequestConfig = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};

// ****************************************************************************************************************************************

export const getData = async (api_url: string) => {
    let resData;
    await axiosBackendInstance
        .get(`${api_url}`, defaultRequestConfig)
        .then((res) => {
            resData = res.data;
        })
        .catch((err) => {
            resData = err;
        });
    return resData;
};

// ****************************************************************************************************************************************

export const postData = async (api_url: string, payload: LooseObject) => {
    let resData;
    await axiosBackendInstance
        .post(`${api_url}`, payload, defaultRequestConfig)
        .then((res) => {
            resData = res.data;
        })
        .catch((err) => {
            resData = err.response.data;
        });
    return resData;
};

// ****************************************************************************************************************************************
